import { useState } from "react";
import SectionHead from "./SectionHead";
import useLang from "../i18n/LanguageContext";
import "./Skills.css";

// Keycap color per skill, in the same order as t.skills.items
const KINDS = ["accent", "alpha", "alpha", "alpha", "mod", "space"];

const Skills = () => {
  const { t } = useLang();
  const [picked, setPicked] = useState(-1);

  return (
    <section id="skills" className="section">
      <div className="section__inner">
        <SectionHead fkey="F2" title={t.skills.title} intro={t.skills.intro} />
        <ul className="skills">
          {t.skills.items.map((s, i) => (
            <li
              key={s.name}
              className={`skills__item${picked >= 0 && picked !== i ? " is-dim" : ""}`}
              data-critter={`skill-${i}`}
            >
              <button
                type="button"
                className={`skill-key key--${KINDS[i]}`}
                style={{ animationDelay: `${i * 0.12}s` }}
                aria-pressed={picked === i}
                onClick={() => setPicked((p) => (p === i ? -1 : i))}
              >
                <span className="skill-key__name">{s.name}</span>
                <span className="skill-key__cap">{s.cap}</span>
              </button>
              <span className="skills__note">{s.note}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Skills;
